import React from "react";
import { IconShoppingCart, IconReceiptRefund, IconBell } from "@tabler/icons-react";
import "./Notifications.css";

const TYPE_ICONS = {
  order: IconShoppingCart,
  refund: IconReceiptRefund,
};

export default function NotificationItem({ item, onClick }) {
  const Icon = TYPE_ICONS[item.type] || IconBell;

  return (
    <div
      className={`notif-item ${item.unread ? "unread" : ""}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onClick?.()}
    >
      {item.unread && <span className="notif-dot" aria-hidden="true" />}

      <div className="notif-icon-wrap">
        <Icon size={19} />
      </div>

      <div className="notif-main">
        <div className="notif-top">
          <strong className="notif-name">{item.name}</strong>
          <small className="notif-time">{item.time}</small>
        </div>
        <div className="notif-text">{item.message}</div>
      </div>
    </div>
  );
}
